import { AxiosResponse } from "axios";
import { oldBaseApi } from "../../api";

type RefreshJwtTokenResponse = {
  jwtToken: string;
  refreshToken: string;
  keycloak: {
    accessToken: string;
    expiresIn: number;
    refreshToken: string;
    tokenType: string;
  };
};

export const refreshJwtToken = (
  refreshToken: string,
): Promise<AxiosResponse<RefreshJwtTokenResponse>> => {
  return oldBaseApi.post(`api/tokens/jwt/refresh`, refreshToken);
};
